import { DYN_FLAG } from 'src/helpers/modular/detailedSummaryReport/interfaces';
import Utils from 'src/utils';
import { confirmationStatusesToMap } from 'src/helpers/modular/mainReportConfirmationUtil';
const { decapitalize } = Utils.strings;
class RowsParser {
    static parse(departments, mainReportConfirmations) {
        const rows = [];
        const mainReportConfirmationsMap = confirmationStatusesToMap(mainReportConfirmations);
        departments.forEach((department) => {
            department.Users.forEach((user) => {
                const row = this.getRowData(user, department);
                row.meta = this.getRowMeta(user, department, mainReportConfirmationsMap);
                rows.push(row);
            });
            if (departments.length > 1) {
                rows.push(this.getDepartmentTotals(department));
            }
        });
        return rows;
    }
    static getRowData(user = {}, department) {
        return {
            meta: {},
            userData: this.getUserDataValues(user, department),
            periodNorm: this.getPeriodNormValue(user),
            userActual: this.getUserActualValue(user),
            workHours: this.getWorkHoursValues(user.CalculatedWorkHours || {}),
            contractTransferedFreeTime: this.getContractTransferedFreeTime(user.CalculatedWorkHours || {}),
            contractUsedFreeTime: this.getContractUsedFreeTime(user.CalculatedWorkHours || {}),
            contractUnusedFreeTime: this.getContractUnusedFreeTime(user.CalculatedWorkHours || {}),
            freeDays: this.getFreeDaysValue(user.Absences || {}),
            absences: this.getAbsencesValues(user.Absences?.Absences || []),
            overUnder: this.getOverUnderValue(user.CalculatedWorkHours || {}),
            contractOverUnder: this.getContractOverUnderValue(user.CalculatedWorkHours || {})
        };
    }
    static getDepartmentTotals(department) {
        const totals = this.getRowData(department.UsersSums, department);
        totals.meta = {
            isDepartmentTotal: true,
            rowKey: `department-totals-${department.DepartmentName}-${department.DepartmentCode}`
        };
        return totals;
    }
    static getUserDataValues(user, department) {
        return {
            userName: user.UserName || '',
            userCode: user.UserCode || '',
            departmentName: department?.DepartmentName || '',
            departmentCode: department?.DepartmentCode || '',
            professionName: user.Profession || ''
        };
    }
    static getPeriodNormValue(user) {
        return {
            hours: user.PeriodNormHours,
            timespan: user.PeriodNormTime
        };
    }
    static getUserActualValue(user) {
        return {
            hours: user.UserActualHours,
            timespan: user.UserActualTime
        };
    }
    static getWorkHoursValues(calculatedWorkHours) {
        const dynamicWorks = calculatedWorkHours.CalculatedDynamicWorkHours?.Values || [];
        const dynamicExtras = calculatedWorkHours.CalculatedDynamicExtraHours?.Values || [];
        return {
            individualNorm: {
                hours: calculatedWorkHours.IndividualNormHours,
                timespan: calculatedWorkHours.IndividualNormTime
            },
            work: {
                hours: calculatedWorkHours.WorkHours,
                timespan: calculatedWorkHours.WorkTime
            },
            extra: {
                hours: calculatedWorkHours.ExtraHours,
                timespan: calculatedWorkHours.ExtraTime
            },
            training: {
                hours: calculatedWorkHours.TrainingHours,
                timespan: calculatedWorkHours.TrainingTime
            },
            watch: {
                hours: calculatedWorkHours.WatchHours,
                timespan: calculatedWorkHours.WatchTime
            },
            ...this.getDynamicRows(dynamicWorks, DYN_FLAG.WORK),
            ...this.getDynamicRows(dynamicExtras, DYN_FLAG.EXTRA)
        };
    }
    static getDynamicRows(rows, keyFlag) {
        const result = {};
        rows.forEach((row) => {
            const key = `${decapitalize(row.Name)}-${keyFlag}`;
            result[key] = {
                hours: row.DynHours,
                timespan: row.DynTime
            };
        });
        return result;
    }
    static getContractTransferedFreeTime(calculatedWorkHours) {
        return {
            hours: calculatedWorkHours.ContractTransferedFreeHours,
            timespan: calculatedWorkHours.ContractTransferedFreeTime
        };
    }
    static getContractUsedFreeTime(calculatedWorkHours) {
        return {
            hours: calculatedWorkHours.ContractUsedFreeHours,
            timespan: calculatedWorkHours.ContractUsedFreeTime
        };
    }
    static getContractUnusedFreeTime(calculatedWorkHours) {
        return {
            hours: calculatedWorkHours.ContractUnusedFreeHours,
            timespan: calculatedWorkHours.ContractUnusedFreeTime
        };
    }
    static getFreeDaysValue(absences) {
        return absences?.FreeDays || 0;
    }
    static getAbsencesValues(absences) {
        const result = {};
        absences.forEach((absence) => {
            result[decapitalize(absence.Name)] = {
                name: absence.Name,
                code: absence.ExternalCode,
                days: absence.Days,
                duration: {
                    hours: absence.AbsHours,
                    timespan: absence.AbsTime
                }
            };
        });
        return result;
    }
    static getOverUnderValue(calculatedWorkHours) {
        return {
            hours: calculatedWorkHours.OverUnderHours,
            timespan: calculatedWorkHours.OverUnderTime
        };
    }
    static getContractOverUnderValue(calculatedWorkHours) {
        return {
            hours: calculatedWorkHours.ContractOverUnderHours,
            timespan: calculatedWorkHours.ContractOverUnderTime
        };
    }
    static getRowMeta(user, department, mainReportConfirmationsMap) {
        return {
            rowKey: `${user.Id}-${department.DepartmentName}-${department.DepartmentCode}`,
            isConfirmedInMainReport: mainReportConfirmationsMap[user.Id] || false
        };
    }
}
export default RowsParser;
